import React from 'react'
import {
  Card,
  Table,
  Button,
  Input,
  Divider,
  Collapse,
  Row,
  Col,
  Modal,
  Form,
  Tooltip,
  message,
  Spin,
  Tabs,
  InputNumber,
  Switch,
  Tag
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import UserHelpPic from '../../../assets/images/User-Help.png'
import { useHistory } from 'react-router-dom'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { useStore, useDispatch, useSelector } from 'react-redux'
import { loadData } from '../../../appRedux/actions/Setting'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { USERROLES_SCREEN } from '../../../constants/Pages'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import {
  notAllowMsgCheck,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const Panel = Collapse.Panel
const { TabPane } = Tabs

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const UsersListing = () => {
  const store = useStore()
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const history = useHistory()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [isLoading, setIsLoading] = React.useState(true)
  const [isRoleLoading, setRoleLoading] = React.useState(true)
  const [getIsRole, setIsRole] = React.useState(false)
  const [getRoleModal, setRoleModal] = React.useState(false)
  const [getTableData, setTableData] = React.useState([])
  const [getTableRolesData, setTableRolesData] = React.useState([])
  const [loadDataState, setloadDataState] = React.useState(false)
  const [getCurrSymbol, setCurrSymbol] = React.useState('')
  const [getIsAllowRead, setIsAllowRead] = React.useState(false)
  const [getIsDisableCreate, setIsDisableCreate] = React.useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = React.useState(true)
  const [getIsDisableCreateRole, setIsDisableCreateRole] = React.useState(true)
  const [getIsDisableUpdateRole, setIsDisableUpdateRole] = React.useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = React.useState(true)
  const [getAccessLoading, setAccessLoading] = React.useState(true)
  const [getRights, setRights] = React.useState([])
  const [getPermissions, setPermissions] = React.useState([])

  //rights & permissions
  React.useEffect(() => {
    let commonData = getReduxCommonSetting
    let rites = []
    let permissions = []
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
    ) {
      if (commonData.storeCommonConfigs.storeConfig.currencyData) {
        let currencyData =
          commonData.storeCommonConfigs.storeConfig.currencyData
        setCurrSymbol(currencyData.currencySymbol)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
          .length > 0
      ) {
        rites =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setRights(rites)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission.length > 0
      ) {
        permissions =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setPermissions(permissions)
      }
    }

    if (rites.length > 0) {
      if (rites.filter(a => a == READ).length > 0) {
        setIsAllowRead(true)
      }
      if (rites.filter(a => a == CREATE).length > 0) {
        setIsDisableCreate(false)
        setIsDisableCreateRole(false)
      }
      if (rites.filter(a => a == UPDATE).length > 0) {
        setIsDisableUpdate(false)
        setIsDisableUpdateRole(false)
      }
      if (rites.filter(a => a == DELETE).length > 0) {
        setIsDisableDelete(false)
      }
    }

    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false)
    }
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    dispatch(setCommonConfigs(USERROLES_SCREEN))
    getUsersService()
    getRolesService()
  }, [])

  React.useEffect(() => {
    if (store.getState().settings.loadData) {
      setIsLoading(true)
      setRoleLoading(true)
      getUsersService()
      getRolesService()
    }
    handleChange()
    const unsub = store.subscribe(handleChange)
    return () => {
      unsub()
    }
  }, [loadDataState])

  // React.useEffect(() => {
  //   let mounted = true
  //   if (mounted) {
  //     if (!verifyPkgFeature(PkgFeatures.CustomUserRoles) && getRoleModal) {
  //       setIsDisableCreate(true)
  //       setIsDisableUpdate(true)
  //     }
  //   }
  //   return () => {
  //     mounted = false
  //   }
  // }, [getRoleModal])

  const handleChange = () => {
    if (store.getState().settings.loadData != loadDataState) {
      setloadDataState(store.getState().settings.loadData)
      dispatch(loadData(false))
    }
  }

  async function getUsersService () {
    // ;
    const getUsers = ds.getUserList('', BEHAVIOUR_TYPE.GET)
    await getUsers
      .then(response => {
        setIsLoading(false)
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            if (response.data.data) {
              let data = response.data.data
              let usersData = data.map(e => {
                let daily = `dailyTarget(${e.sUserId})`
                let week = `weeklyTarget(${e.sUserId})`
                let month = `monthlyTarget(${e.sUserId})`
                form.setFieldsValue({ [daily]: e.dailyTarget })
                form.setFieldsValue({ [week]: e.weeklyTarget })
                form.setFieldsValue({ [month]: e.monthlyTarget })
                let outlets = ''
                if (e.outletName && e.outletName.length > 0) {
                  for (let i = 0; i < e.outletName.length; i++) {
                    let name = e.outletName[i].OutletName
                    if (outlets == '') {
                      outlets = outlets.concat(name)
                    } else {
                      outlets = outlets.concat(', ').concat(name)
                    }
                  }
                }
                return {
                  userid: e.sUserId,
                  username: e.userName,
                  userrole: e.roleName,
                  useroutlet: outlets,
                  dailytarget: e.dailyTarget,
                  weeklytarget: e.weeklyTarget,
                  monthlytarget: e.monthlyTarget,
                  lastactive: '2 Hours Ago',
                  enabled: e.isActive,
                  isOwner: e.isOwner
                }
              })
              setTableData(usersData)
              if (loadDataState) {
                setloadDataState(false)
              }
            } else {
              setIsLoading(false)
              message.error('Something Went Wrong...')
            }
          } else {
            setIsLoading(false)
            message.error('Something Went Wrong...')
          }
        } else {
          setIsLoading(false)
          message.error('Something Went Wrong...')
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setIsLoading(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      })
  }

  async function postUsersInfo (body, isEnable) {
    // ;
    const postUsersInfo = ds.postUsersInfo(body, BEHAVIOUR_TYPE.UPDATE)
    await postUsersInfo
      .then(response => {
        // setIsLoading(false);
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            let data = response.data.data
            if (isEnable) {
              if (isEnable.includes('disable')) {
                let name = isEnable.split('/')
                message.success(`${name[1]} is Disabled`)
              } else {
                let name = isEnable.split('/')
                message.success(`${name[1]} is Enabled`)
              }
            } else {
              message.success(`Target Saved`)
            }
          } else {
            message.error('Something Went Wrong...')
          }
        } else {
          message.error('Something Went Wrong...')
        }
      })
      .catch(e => {
        message.error('Try again ...')
        notAllowMsgCheck(e)
        // setIsLoading(false);
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      })
  }

  async function getRolesService () {
    // ;
    const getRoles = ds.getRolesList('', BEHAVIOUR_TYPE.GET)
    await getRoles
      .then(response => {
        setRoleLoading(false)
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            if (response.data.data) {
              let data = response.data.data
              let rolesData = data.map((e, key) => {
                return {
                  key: key,
                  rolename: e.roleName,
                  id: e.sRoleId,
                  rolelastsaved: e.lastSaved
                }
              })
              rolesData.sort((a, b) => (a.key < b.key ? 1 : -1))
              setTableRolesData(rolesData)
              if (loadDataState) {
                setloadDataState(false)
              }
            } else {
              setRoleLoading(false)
              message.error('Something Went Wrong...')
            }
          } else {
            setRoleLoading(false)
            message.error('Something Went Wrong...')
          }
        } else {
          setRoleLoading(false)
          message.error('Something Went Wrong...')
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        setRoleLoading(false)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut(store.getState()));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      })
  }

  // const getTableRolesData = [
  //   {
  //     rolename: "Cashier",
  //     id: "586asd-asd87678-asd6899",
  //     rolelastsaved: "2 Hours Ago",
  //   },
  //   {
  //     rolename: "Manager",
  //     id: "586asd-asd8760078-a00sd6899",
  //     rolelastsaved: "4 Hours Ago",
  //   },
  //   {
  //     rolename: "Admin",
  //     id: "586asfffd-asd8767tt8-asd6833399",
  //     rolelastsaved: "7 Hours Ago",
  //   },
  // ];

  // const getTableData = [
  //   {
  //     userid: "123sdf-sdfsdf-123dsdf-sdff",
  //     username: "Terry Ramsey",
  //     userrole: "Cashier",
  //     useroutlet: "Victor 7th Street",
  //     dailytarget: "100",
  //     weeklytarget: "200",
  //     monthlytarget: "300",
  //     lastactive: "2 Hours Ago",
  //     enabled: true,
  //   },
  //   {
  //     userid: "123sdf-sdfsffdf-123dsdf-sdff",
  //     username: "Neil Jordon",
  //     userrole: "Admin",
  //     useroutlet: "Amanda 7th Street",
  //     dailytarget: "100",
  //     weeklytarget: "200",
  //     monthlytarget: "300",
  //     lastactive: "1 Hours Ago",
  //     enabled: true,
  //   },
  //   {
  //     userid: "123sdrrf-sdfsdf-123dsdf-sdff",
  //     username: "John Berg",
  //     userrole: "Cashier",
  //     useroutlet: "Moon Garden",
  //     dailytarget: "100",
  //     weeklytarget: "200",
  //     monthlytarget: "300",
  //     lastactive: "6 Hours Ago",
  //     enabled: true,
  //   },
  // ];

  function onDailyTargetChange (ev, id, weekly, monthly) {
    // ;
    let body = {
      DailyTarget: ev ? ev : 0,
      MonthlyTarget: monthly ? monthly : 0,
      WeeklyTarget: weekly ? weekly : 0,
      SUserId: id,
      IsUserEnabledUpdate: false
    }
    postUsersInfo(body, false)
  }

  function onWeeklyTargetChange (ev, id, daily, monthly) {
    let body = {
      WeeklyTarget: ev ? ev : 0,
      DailyTarget: daily ? daily : 0,
      MonthlyTarget: monthly ? monthly : 0,
      SUserId: id,
      IsUserEnabledUpdate: false
    }
    postUsersInfo(body, false)
  }

  function onMonthlyTargetChange (ev, id, daily, weekly) {
    let body = {
      MonthlyTarget: ev ? ev : 0,
      DailyTarget: daily ? daily : 0,
      WeeklyTarget: weekly ? weekly : 0,
      SUserId: id,
      IsUserEnabledUpdate: false
    }
    postUsersInfo(body, false)
  }

  function onTargetChange (id) {
    let body = {
      MonthlyTarget: form.getFieldValue(`monthlyTarget(${id})`),
      DailyTarget: form.getFieldValue(`dailyTarget(${id})`),
      WeeklyTarget: form.getFieldValue(`weeklyTarget(${id})`),
      SUserId: id
      // IsUserEnabledUpdate: false,
    }
    postUsersInfo(body, false)
  }

  function onEnabledChange (ev, id, name, daily, monthly, weekly) {
    let body = {
      MonthlyTarget: monthly ? monthly : 0,
      WeeklyTarget: weekly ? weekly : 0,
      DailyTarget: daily ? daily : 0,
      SUserId: id,
      IsUserEnabledUpdate: true,
      UserEnableUpdate: ev
    }
    let isEnable = ''
    if (ev) {
      // message.success(`${name} is Enabled`);
      isEnable = `enabled/${name}`
    } else {
      // message.success(`${name} is Disabled`);
      isEnable = `disable/${name}`
    }
    postUsersInfo(body, isEnable)

    let data = [...getTableData]
    let index = data.findIndex(a => a.userid == id)
    data[index].enabled = ev
    setTableData(data)
  }

  const columns = [
    {
      title: <IntlMessages id='setup.users.col1' />,
      dataIndex: 'username',
      key: 'username',
      render: (text, record) => {
        return (
          <span
            onClick={() =>
              getIsDisableUpdate
                ? ''
                : history.push(
                    `/dashboard/setup/users/edit/${record.userid}/${
                      getIsDisableDelete ? '0' : '1'
                    }`
                  )
            }
            className='gx-link'
            style={{ fontWeight: '500' }}
          >
            {text}
          </span>
        )
      }
    },
    {
      title: <IntlMessages id='setup.users.col2' />,
      dataIndex: 'userrole',
      key: 'userrole',
      render: (text, record) => {
        let role = record.isOwner ? `Owner, ${text}` : text
        return <span style={{ fontWeight: '500' }}>{role}</span>
      }
    },
    {
      title: <IntlMessages id='setup.users.col3' />,
      dataIndex: 'useroutlet',
      key: 'useroutlet',
      render: text => {
        return (
          <span className='' style={{ fontWeight: '500' }}>
            {text}
          </span>
        )
      }
    },
    {
      title: (
        <span>
          <IntlMessages id='setup.users.col4' />
          {` (${getCurrSymbol})`}
        </span>
      ),
      dataIndex: 'dailytarget',
      key: 'dailytarget',
      render: (text, record) => {
        return (
          <Form
            form={form}
            name='targetForm'
            // onFinish={onTargetChange(record.userid)}
            // onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item name={`dailyTarget(${record.userid})`}>
              <InputNumber
                type='number'
                min={0}
                max={10000000}
                // formatter={(value) =>
                //   `${getCurrSymbol} ${value}`.replace(
                //     /\B(?=(\d{3})+(?!\d))/g,
                //     ","
                //   )
                // }
                // parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                step={1}
                // onChange={(ev) => {
                //   setTimeout(() => {
                //     onTargetChange(record.userid);
                //   }, 4000);
                // }}
                onBlur={ev => {
                  onTargetChange(record.userid)
                }}
                disabled={getIsDisableUpdate}
              />
            </Form.Item>
          </Form>
        )
      }
    },
    {
      title: (
        <span>
          <IntlMessages id='setup.users.col5' />
          {` (${getCurrSymbol})`}
        </span>
      ),
      dataIndex: 'weeklytarget',
      key: 'weeklytarget',
      render: (text, record) => {
        return (
          <Form
            form={form}
            name='targetForm'
            // onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item name={`weeklyTarget(${record.userid})`}>
              <InputNumber
                type='number'
                min={0}
                max={1000000000}
                // formatter={(value) => `${value}${getCurrSymbol}`}
                // parser={(value) => value.replace(`${getCurrSymbol}.`, "")}
                step={1}
                // onChange={(ev) => {
                //   setTimeout(() => {
                //     onTargetChange(record.userid);
                //   }, 4000);
                // }}
                onBlur={ev => {
                  onTargetChange(record.userid)
                }}
                disabled={getIsDisableUpdate}
              />
            </Form.Item>
          </Form>
        )
      }
    },
    {
      title: (
        <span>
          <IntlMessages id='setup.users.col6' />
          {` (${getCurrSymbol})`}
        </span>
      ),
      dataIndex: 'monthlytarget',
      key: 'monthlytarget',
      render: (text, record) => {
        return (
          <Form
            form={form}
            name='targetForm'
            // onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item name={`monthlyTarget(${record.userid})`}>
              <InputNumber
                type='number'
                min={0}
                max={10000000000}
                // formatter={(value) => `${value}${getCurrSymbol}`}
                // parser={(value) => value.replace(`${getCurrSymbol}.`, "")}
                step={1}
                // onChange={(ev) => {
                //   setTimeout(() => {
                //     onTargetChange(record.userid);
                //   }, 4000);
                // }}
                onBlur={ev => {
                  onTargetChange(record.userid)
                }}
                disabled={getIsDisableUpdate}
              />
            </Form.Item>
          </Form>
        )
      }
    },
    {
      title: <IntlMessages id='setup.users.col7' />,
      dataIndex: 'edit',
      key: 'edit',
      render: (text, record) => {
        return getIsDisableUpdate ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <div>
            <span>
              <a
                onClick={() =>
                  history.push(
                    `/dashboard/setup/users/edit/${record.userid}/${
                      getIsDisableDelete ? '0' : '1'
                    }`
                  )
                }
                className='pen-edit'
              >
                <i className='icon icon-edit' />
              </a>
            </span>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='setup.users.col8' />,
      dataIndex: 'enabled',
      key: 'enabled',
      render: (text, record) => {
        let isDisable = record.isOwner
        if (!isDisable) {
          isDisable = getIsDisableUpdate
        }
        return (
          <span>
            <a className='gx-link'>
              <Switch
                checked={record.enabled}
                onChange={ev => {
                  onEnabledChange(
                    ev,
                    record.userid,
                    record.username,
                    record.dailytarget,
                    record.monthlytarget,
                    record.weeklytarget
                  )
                }}
                disabled={isDisable}
              />
            </a>
          </span>
        )
      }
    }
  ]

  const columnsRoles = [
    {
      title: <IntlMessages id='setup.users.rolecol1' />,
      dataIndex: 'rolename',
      key: 'rolename',
      render: (text, record) => {
        return (
          <div style={{ cursor: 'pointer' }}>
            <span style={{ fontWeight: '600', cursor: 'pointer' }}>
              <a
                onClick={() =>
                  getIsDisableUpdateRole
                    ? ''
                    : history.push(
                        `/dashboard/setup/users/addeditroles/${
                          record.id
                        }/${text}/${getIsDisableDelete ? '0' : '1'}`
                      )
                }
                className='table-link'
              >
                {text}
              </a>
            </span>
          </div>
        )
      }
    },
    {
      title: <IntlMessages id='setup.users.rolecol2' />,
      dataIndex: 'rolelastsaved',
      key: 'rolelastsaved',
      render: text => {
        let date = new Date(text)
        date = date.toLocaleString()
        date = date && date != 'Invalid Date' ? date : ''
        return <span style={{ fontWeight: '500' }}>{date}</span>
      }
    },
    {
      title: <IntlMessages id='setup.users.col7' />,
      dataIndex: 'rolename',
      key: 'rolename',
      render: (text, record) => {
        return getIsDisableUpdateRole ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <div>
            <span>
              <a
                onClick={() =>
                  history.push(
                    `/dashboard/setup/users/addeditroles/${record.id}/${text}/${
                      getIsDisableDelete ? '0' : '1'
                    }`
                  )
                }
                className='pen-edit'
              >
                <i className='icon icon-edit' />
              </a>
            </span>
          </div>
        )
      }
    }
  ]

  const onFinish = values => {
    // ;
    message.success('onFinish')
  }

  const onFinishFailed = errorInfo => {
    //;
    // message.error("Kindly Attend to Missing Fields");
  }

  function handleCancel () {
    message.success('cancel')
  }

  function onTabClick (e) {
    if (e == 2) {
      setIsRole(true)
    } else {
      setIsRole(false)
    }
  }

  const handleOk = () => {
    setRoleModal(false)
    // setConfirmLoading(true);
    // setTimeout(() => {
    //   setVisible(false);
    //   setConfirmLoading(false);
    // }, 2000);
  }

  const handleCancelModal = () => {
    //;
    //props['IsShow'] = false;
    setRoleModal(false)
  }

  const onFinishFailedModal = errorInfo => {
    message.error('Something went wrong, please try again')
  }

  const onFinishModal = values => {
    if (values.roleName) {
      history.push(`/dashboard/setup/users/addeditroles/new/${values.roleName}`)
    }
  }

  const AddRoleModal = () => {
    return (
      <Modal
        title={<IntlMessages id='setup.users.newrole' />}
        visible={getRoleModal}
        onOk={handleOk}
        onCancel={handleCancelModal}
        centered={true}
        // width={"402px"}'
        footer={
          <>
            <Button
              form='roleForm'
              className=''
              type='primary'
              htmlType='submit'
              size='large'
            >
              <IntlMessages id='setup.users.addrolerights' />
            </Button>
          </>
        }
      >
        <Form
          {...formItemLayout}
          form={form}
          name='roleForm'
          onFinish={onFinishModal}
          onFinishFailed={onFinishFailedModal}
          initialValues={{
            prefix: '86'
          }}
          scrollToFirstError
        >
          <Form.Item
            className='ant-form-item-label-custom ant-form-margin-right'
            name='roleName'
            label={
              <span>
                <strong>
                  <IntlMessages id='setup.users.rolename' />
                </strong>
                <Tooltip title='Role Name'></Tooltip>
              </span>
            }
            rules={[
              {
                required: true,
                message: <IntlMessages id='setup.users.rolenamerule' />,
                whitespace: true
              }
            ]}
          >
            <Input placeholder='Role Name' maxLength={80} />
          </Form.Item>
        </Form>
      </Modal>
    )
  }

  return getIsAllowRead ? (
    <div className='Content-wrapper Users-pg'>
      <Row className='align-items-center justify-content-between mb-3 Product-header'>
        <Col md={6}>
          {getIsRole ? (
            <>
              <h1 className='mb-0'>
                <IntlMessages id='setup.users.titlerole' />
              </h1>
            </>
          ) : (
            <>
              <h1 className='mb-0'>
                <IntlMessages id='setup.users.title' />
              </h1>
            </>
          )}
        </Col>

        <Col md={18}>
          {!getIsRole && (
            <div className='pg-header-btn'>
              <Button
                className='dk-btn-add'
                type='primary'
                onClick={() => {
                  history.push('/dashboard/setup/users/add')
                }}
                disabled={getIsDisableCreate}
                size='large'
              >
                <IntlMessages id='setup.users.adduser' />
              </Button>
            </div>
          )}
          {getIsRole && (
            <div className='pg-header-btn'>
              <Button
                className='dk-btn-add'
                type='primary'
                onClick={() => {
                  if (!verifyPkgFeature(PkgFeatures.CustomUserRoles)) {
                    setIsDisableCreateRole(true)
                    setIsDisableUpdateRole(true)
                  } else {
                    setRoleModal(true)
                  }
                }}
                disabled={getIsDisableCreateRole}
                size='large'
              >
                <IntlMessages id='setup.users.addrole' />
              </Button>
            </div>
          )}
        </Col>
      </Row>

      <Tabs
        className='no-overflow'
        defaultActiveKey='1'
        size='large'
        onChange={e => onTabClick(e)}
      >
        <TabPane tab={<IntlMessages id='setup.users.usertab' />} key='1'>
          <Card className='gx-card' title=''>
            <Collapse>
              <Panel
                className='custom-promolist-help'
                showArrow={false}
                header={<IntlMessages id='setup.users.needhelp' />}
              >
                <Row>
                  <div className='billing-main'>
                    <Col className='custom-promolist-helpdesc' md={12}>
                      <p>
                        <IntlMessages id='setup.users.needhelp1' />
                      </p>
                      <p>
                        <IntlMessages id='setup.users.needhelp2' />
                      </p>
                      <p>
                        <IntlMessages id='setup.users.needhelp3' />
                      </p>
                    </Col>

                    <Col md={12}>
                      <img src={UserHelpPic} alt='' />
                    </Col>
                  </div>
                </Row>
              </Panel>
            </Collapse>
          </Card>

          <div className='Users-table'>
            {isLoading ? (
              <Skeleton count={5} height={30} />
            ) : (
              <Table
                className='gx-table-responsive'
                columns={columns}
                dataSource={getTableData}
              />
            )}
          </div>
        </TabPane>

        <TabPane tab={<IntlMessages id='setup.users.rolestab' />} key='2'>
          <Card className='gx-card' title=''>
            <Collapse>
              <Panel
                className='custom-promolist-help'
                showArrow={false}
                header={<IntlMessages id='setup.users.rolescollapse' />}
              >
                <Row>
                  <div className='billing-main'>
                    <Col className='custom-promolist-helpdesc' md={12}>
                      <p>
                        <IntlMessages id='setup.users.rolescollapse1' />
                      </p>
                    </Col>

                    <Col md={12}>{/* <img src={UserHelpPic} alt="" /> */}</Col>
                  </div>
                </Row>
              </Panel>
            </Collapse>
          </Card>

          <div className='Users-table'>
            {isRoleLoading ? (
              <Skeleton count={5} height={30} />
            ) : (
              <Table
                className='gx-table-responsive'
                columns={columnsRoles}
                dataSource={getTableRolesData}
              />
            )}
          </div>
        </TabPane>
      </Tabs>
      <AddRoleModal />
    </div>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default UsersListing
